function groupNotificationsByEntryId(notifications) {
  return new Map(Object.entries(notifications.reduce((acc, curr) => {
    acc[curr.relatedEntryId ?? ""] ??= [];
    acc[curr.relatedEntryId ?? ""]?.push(curr);
    return acc;
  }, {})));
}

export { groupNotificationsByEntryId };
//# sourceMappingURL=util.group-notifications-by-entry-id.js.map
